import { Chat } from '@tunasong/plugin-chat/ui'
import { useCommentGroups } from '@tunasong/plugin-comment/ui'
import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { PanelEmptyState } from './panel-empty-state.js'

/**
 * The song's people Chat (chat makeover M3, #2718): song-level comments, plus one group per commented block in the
 * open song, by latest activity. The composer writes song-level comments; replies to a group go in its block's popup.
 */
export const SidebarChat: FC<SidebarComponent> = ({ entity }) => {
  const { groups, loadOlder } = useCommentGroups(entity?.id)
  return (
    <Chat
      element={entity}
      showTabs={false}
      resolvable={true}
      groups={groups}
      onLoadOlder={loadOlder}
      emptyState={<PanelEmptyState title="No open comments" body="Select a line in the song to start a thread." />}
    />
  )
}
